import JsxParser from 'react-jsx-parser'
import moment from 'moment'

export const renderJSXValueCell = (
  // Содержимое самого скрипта
  value: string,
  srcObj: Record<string, unknown>
) => {
  return (
    <div style={{ pointerEvents: 'none' }}>
      {/* eslint-disable-next-line */}
      {/* @ts-ignore */}
      <JsxParser bindings={{ srcObj, Object, Array, moment, Math }} jsx={value} />
    </div>
  )
}
